<template>
	<div class="accountManagement">
		<div>{{$t('other.a1958')}}</div>
		<div style="display: flex;justify-content: space-between;">
			<div v-if="show === 'resetLoginPws'||show === 'loginPage'" class="not-edit-all">
				<span>{{$t('other.a464')}}</span>
				<el-tabs v-model="activeName">
					<el-tab-pane :label="$t('other.a1959')" name="first">
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a427')}}</label>
						<el-select v-model="areaCode"  :placeholder="$t('other.a50')">
							<el-option
							v-for="item in distrisAread"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1965')}}</label>
					<el-input size="mini" v-model="sizephoneForm.phone" :placeholder="$t('other.a399')"></el-input>
				</div>
				<span style="margin-top: 30px;display: inline-block;">{{$t('other.a1966')}}</span>
				
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1967')}}</label><el-input size="mini" type="password" v-model="sizephoneForm.password" :placeholder="$t('other.a1961')"></el-input>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1968')}}</label>
					<el-input size="mini" v-model="sizephoneForm.phoneCode"  :placeholder="$t('other.a1960')"></el-input>
					<span style="cursor: pointer;" @click="getphoneCode">{{$t('other.a402')}}</span>
				</div>
				<div style="margin-top: 20px;width: 100%;display: flex;justify-content: center;">
					<el-button style="100%" type="primary" @click="onSubmit">{{$t('other.a166')}}</el-button>
				</div>
					</el-tab-pane>
					<el-tab-pane :label="$t('other.a1962')" name="second">
						
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1969')}}</label>
					<el-input size="mini" v-model="sizeForm.email" :placeholder="$t('other.a1757')"></el-input>
				</div>
				<span style="margin-top: 30px;display: inline-block;">{{$t('other.a1966')}}</span>
				
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1967')}}</label><el-input size="mini" type="password" v-model="sizeForm.password" :placeholder="$t('other.a1961')"></el-input>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a535')}}</label>
					<el-input size="mini" v-model="sizeForm.emailCode"  :placeholder="$t('other.a1963')"></el-input>
					<span style="cursor: pointer;" @click="getemailCode">{{$t('other.a402')}}</span>
				</div>
				<div style="margin-top: 20px;width: 100%;display: flex;justify-content: center;">
					<el-button style="100%" type="primary" @click="onSubmit">{{$t('other.a166')}}</el-button>
				</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div v-if="show == 'resetSecondPws'" class="not-edit-all">
				<span>{{$t('other.a1970')}}</span>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1969')}}</label>
					<el-input size="mini" v-model="seconPws.email" :placeholder="$t('other.a1757')"></el-input>
				</div>
				<span style="margin-top: 30px;display: inline-block;">{{$t('other.a1809')}}</span>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a1967')}}</label><el-input size="mini" type="password" v-model="seconPws.newPassword" :placeholder="$t('other.a1964')"></el-input>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a535')}}</label>
					<el-input size="mini" v-model="seconPws.emailCode"  :placeholder="$t('other.a1963')"></el-input>
					<span style="cursor: pointer;" @click="getemailCodeBysecondPws">{{$t('other.a402')}}</span>
				</div>
				<div style="margin-top: 20px;width: 100%;display: flex;justify-content: center;">
					<el-button style="100%" type="primary" @click="resetPws">{{$t('other.a166')}}</el-button>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import md5 from 'js-md5';
	import {mapState, mapActions , mapMutations} from 'vuex'
	import newOrders from '@/api/moudles/newOrders' 
  export default {
    data() {
      return {
		activeName:'second',
        sizephoneForm: {
          phone: '',
          password: '',
          phoneCode: '',
        },
        sizeForm: {
          email: '',
          password: '',
          emailCode: '',
        },
		seconPws:{
			email:'',
			emailCode:'',
			newPassword:'', 
			oldPassword:'',
			userAccount:this.userId
		},
				 areaCode:'+86',
				 
				 distrisAread:[{
                        value: '+86',
                        label: 'China(+86)'
                    },{
                        value: '+63',
                        label: 'Philippines(+63)'
				 }, {
                        value: '+65',
                        label: 'Singapore(+65)'
				 }, {
                        value: '+84',
                        label: 'Vietnam(+84)'
				 },{
                        value: '+60',
                        label: 'Malaysia(+60)'
				 },{
                        value: '+34',
                        label: 'Spain(+34)'
				 },{
                        value: '+62',
                        label: 'Indonesia(+62)'
				 },{
                        value: '+66',
                        label: 'Thailand(+66)'
				 },{
                        value: '+351',
                        label: 'Portugal(+Portugal)'
				 },{
                        value: '+886',
                        label: 'Taiwan(+886)'
				 }],
      };
    },
	computed:{
		...mapState({
			userId: state=>state.login.userInfo.userId || '',
			userEmail: state=>state.login.userInfo.userEmail || '',
		}),
	},	
	created(){
		console.log(document.getElementsByClassName('personal-aside')[0])
		let self = this
		setTimeout(function(){
		if(self.$route.query.from == 'loginPage'){
			document.getElementsByClassName('personal-aside')[0].style.display = 'none'
		}
		},200)
		self.init()
	},
    methods: {
		...mapActions('login',[
			'getEmailCode_changepws',
			'changePws'
			
		]),
		...mapActions('shopaccess',[
			'resetSecondyPassword'
			
		]),
		init(){
			this.seconPws.email=this.userEmail
			this.sizeForm.email=this.userEmail
			if(this.$route.query.key){
				this.show=this.$route.query.key
				console.log(this.show)
			}
		},
		
		
		resetPws(){
			
			
			let params={
				newPassword:this.seconPws.newPassword,
				emailCode:this.seconPws.emailCode,
				userAccount:this.userId,
			}
			
			this.resetSecondyPassword(params)
		},
		getphoneCode(){
			if(!this.sizephoneForm.phone) {
				this.$message.error(this.$t('other.a1971'))
				return
			}else{
				newOrders
                    .getPhoneCodePassword({
                        country:this.areaCode,
                        phone:this.sizephoneForm.phone
                    })
                    .then(res => {
                    if(res.code === 200 ){
						if(res.data=='账户余额不足'){
							this.$toast({
								message:this.$t('other.a439'),
								position:'center'
							})
						}else{
							this.$toast({
								message:this.$t('other.a440'),
								position:'center'
							})
						}
                    
					
                    }else{
						this.$toast({
							message:res.msg,
							position:'center'
						})
                    }
                    })
			}
		},
	  getemailCode(){
	  	
	  	if(!this.sizeForm.email) {
	  		this.$message.error(this.$t('other.a523'))
	  		return
	  	}else{
		
	
	  		const params={
	  			email:this.sizeForm.email
	  		}
	  		this.getEmailCode_changepws(params)
	  	}
	  	
	  },
	  getemailCodeBysecondPws(){
		 
		  if(!this.seconPws.email) {
		  	this.$message.error(this.$t('other.a523'))
		  	return
		  }else{
		  
	
		  	const params={
		  		email:this.seconPws.email
		  	}
		  	this.getEmailCode_changepws(params)
		  }
	  },
	  onSubmitphone(){
		  const params={
		  	email:this.sizephoneForm.phone,
		  	password:md5(this.sizephoneForm.password + 'seller'),
		  	emailCode:this.sizephoneForm.phoneCode,
			userId:JSON.parse(localStorage.getItem('userInfo')).userId,
		  }
		  console.log(params)
		  this.changePws(params).then(res => {
			  if(res.code === 200){
				  this.$message.success(this.$t('other.a1972'))
				  setTimeout(() => {
					  localStorage.removeItem('userInfo')
						localStorage.removeItem('warehouse')
						localStorage.removeItem('shopIdInfo')
						localStorage.removeItem('secondPws')
						localStorage.removeItem('storeId')
						location.replace('/index')
				  },500)

				    this.sizeForm.password=''
		 			 this.sizeForm.emailCode=''
			  }else{
				  this.$message.error(res.msg)
			  }
		  })
	  },
      onSubmit() {
		let params ={}
		  if(this.activeName=='second'){
			params={
				email:this.sizeForm.email,
				password:md5(this.sizeForm.password + 'seller'),
				emailCode:this.sizeForm.emailCode,
				userId: this.$route.query.from&&this.$route.query.from == 'loginPage'?this.sizeForm.email : JSON.parse(localStorage.getItem('userInfo')).userId,
				changeType:1
			}
		  }else{
			params={
				phone:this.sizephoneForm.phone,
				password:md5(this.sizephoneForm.password + 'seller'),
				phoneCode:this.sizephoneForm.phoneCode,
				userId:this.$route.query.from&&this.$route.query.from == 'loginPage'?this.sizephoneForm.phone :JSON.parse(localStorage.getItem('userInfo')).userId,
				changeType:2
			}
		  }
		  console.log(params)
		  this.changePws(params).then(res => {
			  if(res.code === 200){
				  this.$message.success(this.$t('other.a1972'))
				  setTimeout(() => {
					  localStorage.removeItem('userInfo')
						localStorage.removeItem('warehouse')
						localStorage.removeItem('shopIdInfo')
						localStorage.removeItem('secondPws')
						localStorage.removeItem('storeId')
						location.replace('/index')
				  },500)

				    this.sizeForm.password=''
		 			 this.sizeForm.emailCode=''
			  }else{
				  this.$message.error(res.msg)
			  }
		  })
		
      }
    }
  };
</script>

<style>
	.accountManagement .not-edit-all{
		width:320px;
		margin: 78px auto;
		
		
	}
	.accountManagement .edit-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #9797a1;
		font-size: 14px;
		height: 40px;
		margin-top: 20px;
		border-bottom: 1px solid #e3e3e3
	}
	
	.accountManagement .el-input__inner{
		width: 170px;
		border: none!important;
	}
	.accountManagement .el-input--mini{
		width: 170px!important;
	}
</style>
